import * as hash from 'object-hash';
import { BehaviorSubject, } from 'rxjs';
export var SIDEBAR_SECTION_TYPES = ['Monitoring', 'Automations', 'Management'];
export var PageCategory;
(function (PageCategory) {
    PageCategory[PageCategory["Host"] = 0] = "Host";
    PageCategory[PageCategory["Tenant"] = 1] = "Tenant";
    PageCategory[PageCategory["Unauthorized"] = 2] = "Unauthorized";
    PageCategory[PageCategory["All"] = 3] = "All";
})(PageCategory || (PageCategory = {}));
export var PageScope;
(function (PageScope) {
    PageScope[PageScope["Global"] = 0] = "Global";
    PageScope[PageScope["Folder"] = 1] = "Folder";
})(PageScope || (PageScope = {}));
export var SIDEBAR_SECTION_METADATA = {
    Management: {
        translateKey: 'sidebar_section_management',
        svgIcon: 'uipath:global',
    },
    Automations: {
        translateKey: 'sidebar_section_automations',
        fontIcon: 'folder',
    },
    Monitoring: {
        translateKey: 'sidebar_section_monitoring',
        fontIcon: 'folder',
    },
};
export var convertToCategory = function (state) {
    switch (state) {
        case 0 /* NotLoggedIn */:
            return PageCategory.Unauthorized;
        case 1 /* LoggedInAsTenant */:
            return PageCategory.Tenant;
        case 2 /* LoggedInAsHost */:
            return PageCategory.Host;
        default:
            return PageCategory.All;
    }
};
var PageMetadata = /** @class */ (function () {
    function PageMetadata(_a, parent) {
        var title = _a.title, translationKey = _a.translationKey, routerLink = _a.routerLink, category = _a.category, permission = _a.permission, featureFlag = _a.featureFlag, licenseFlag = _a.licenseFlag, folderTypeDependency = _a.folderTypeDependency, type = _a.type, icon = _a.icon, svgIcon = _a.svgIcon, subtitle = _a.subtitle, isWhitelisted = _a.isWhitelisted, scope = _a.scope, priority = _a.priority, sidebarSection = _a.sidebarSection, folderTypeDependencyMessage = _a.folderTypeDependencyMessage;
        this.customTitle$ = new BehaviorSubject('');
        this._removeRouteParam = function (link) {
            var lastPartIdx = link.lastIndexOf('/');
            if (lastPartIdx + 1 === link.indexOf(':')) {
                link = link.substring(0, lastPartIdx);
            }
            return link;
        };
        this.title = title;
        this.translationKey = translationKey;
        this.routerLink = routerLink;
        this.category = category;
        this.folderTypeDependency = folderTypeDependency;
        this.sidebarSection = sidebarSection;
        this.type = type || 'None';
        this.isWhitelisted = !!isWhitelisted;
        this.featureFlag = featureFlag;
        this.licenseFlag = licenseFlag;
        this.icon = icon;
        this.svgIcon = svgIcon;
        this.subtitle = subtitle;
        this.permission = permission;
        this.scope = scope;
        this.priority = priority != null ? priority : Number.MAX_SAFE_INTEGER;
        this.folderTypeDependencyMessage = folderTypeDependencyMessage;
        this.cleanRouterLink = this._removeRouteParam(this.routerLink);
        this.parent = !!parent ? new PageMetadata(parent) : undefined;
        this.identifier = hash.sha1({
            title: title,
            translationKey: translationKey,
            routerLink: routerLink,
        });
    }
    Object.defineProperty(PageMetadata.prototype, "hasParent", {
        get: function () {
            return !!this.parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PageMetadata.prototype, "customTitle", {
        set: function (value) {
            this.customTitle$.next(value);
        },
        enumerable: true,
        configurable: true
    });
    PageMetadata.prototype.isMatch = function (url) {
        var currentParts = this.routerLink.split('/');
        var urlParts = url.split('/');
        if (currentParts.length < urlParts.length) {
            return false;
        }
        return currentParts.every(function (part, idx) { return (part.startsWith(':') || part === urlParts[idx]); });
    };
    PageMetadata.prototype.equals = function (page) {
        return this === page ||
            this.routerLink === page.routerLink;
    };
    PageMetadata.prototype.isChildOf = function (page) {
        return this.parent &&
            this.parent.routerLink === page.routerLink;
    };
    PageMetadata.prototype.isAccessibleByFolder = function (type) {
        if (!this.folderTypeDependency) {
            return true;
        }
        return this.folderTypeDependency === type;
    };
    return PageMetadata;
}());
export { PageMetadata };
